import { useState } from 'react';
import Container from '@mui/material/Container';
import { useSendContactForm } from 'api';
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import { TextV2 } from '@insights-ltd/design-library/components';
import { Box, Divider, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import Breadcrumbs from 'components/Breadcrumbs';
import { useTranslation } from 'react-i18next';
import FullHeight from 'components/FullHeight';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import ContactForm from './ContactForm';
import { ContactFormData } from './types';
import ContactEmailErrorDialog from './ContactEmailErrorDialog';

const Description = styled(TextV2)({
  maxWidth: '720px',
  lineHeight: '28px,',
});

const Contact = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const { mutate: sendContactEmails } = useSendContactForm();

  const onSubmit: any = (formData: ContactFormData) => {
    sendContactEmails(formData, {
      onSuccess: () => {
        navigate('/contact/thanks');
      },
      onError: () => {
        setIsError(true);
      },
    });
  };
  return (
    <>
      <Helmet>
        <title>{t('ui.event-management.contact.page-title')}</title>
      </Helmet>
      <FullHeight backgroundColor="white">
        <Container>
          <Box
            sx={{
              py: (theme) => theme.spacing(spacingSizeMap.M),
            }}
          >
            <Breadcrumbs
              crumbs={{
                '/': t('ui.event-management.dashboard.home.title'),
              }}
              activeText={t('ui.event-management.contact.breadcrumb-title')}
            />
          </Box>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
            }}
          >
            <Grid>
              <TextV2 component="h1" variant="h2">
                {t('ui.event-management.contact.page-header')}
              </TextV2>
            </Grid>
          </Grid>
          <Box
            sx={{
              my: (theme) => theme.spacing(spacingSizeMap.L),
            }}
          />
          <Divider />
          <Box
            sx={{
              mb: (theme) => theme.spacing(spacingSizeMap.L),
            }}
          />
          <Container
            maxWidth={false}
            sx={{ padding: '0 !important', float: 'left', maxWidth: '720px' }}
          >
            <Box
              sx={{
                mb: (theme) => theme.spacing(spacingSizeMap.S),
              }}
            >
              <Description color="textSecondary">
                {t('ui.event-management.contact.description')}
              </Description>
            </Box>
            <Box>
              <ContactForm onSubmit={onSubmit} />
            </Box>
            <Box
              sx={{
                mb: (theme) => theme.spacing(spacingSizeMap.L),
              }}
            />
          </Container>
        </Container>
      </FullHeight>
      <ContactEmailErrorDialog
        open={isError}
        onClose={() => setIsError(false)}
      />
    </>
  );
};

export default Contact;
